<h1>Product Gallery</h1>

<p>
  Welcome to our product gallery! You'll find many collections of commonly stocked items we carry.
</p>

<div class="row">
  <div class="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-8 col-md-offset-2">
    <app-gallery-searchbar [fieldSize]="'medium'"></app-gallery-searchbar>
  </div>
</div>

<h2>Collections</h2>

<div class="row">
  <div class="col-xs-6 col-sm-3" *ngFor="let collection of collectionKeys">
    <nb-card
      accent="primary"
      class="gallery-landing-card"
      routerLink="/gallery/collection/{{ collection }}"
    >
      <nb-card-header>
        <span class="gallery-landing-thumbnail">
          {{ COLLECTIONS[collection]?.name }}
        </span>
      </nb-card-header>
      <nb-card-body>
        <img [src]="collectionThumbnails.get(collection)" />
      </nb-card-body>
    </nb-card>
  </div>
</div>
